import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import WorkflowForm from '../WorkflowForm/WorkflowForm';
import PageTitle from '../../../components/PageTitle/PageTitle';

import { startCreateWorkflow, createWorkflow } from '../../../redux/modules/workflows';

const WorkflowCreate = () => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(startCreateWorkflow());
    }, [dispatch])

    const submit = (values) => {
        dispatch(createWorkflow(values));
    }

    const { workflowSuccessfullyCreated } = useSelector(state => state.workflows);

    let title = <span>{t('workflows.add')}</span>;

    const actions =
        <Button tag={Link} to="/workflows" color="warning" size="sm">
            <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.back')}
        </Button>

    return (
        <div className="WorkflowCreate">
            <PageTitle icon="code-fork" title={ title } actions={ actions } />

            {workflowSuccessfullyCreated &&
                <Redirect to="/workflows"/>
            }

            <WorkflowForm onSubmit={ submit } isCreation="true" />
        </div>
    );
}

export default WorkflowCreate
